import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CheckinHistoryComponent } from './checkin-history.component';

const routes: Routes = [
  {
    path: "",
    component: CheckinHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CheckinHistoryRoutingModule { }
